import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    show_loading: false,
    is_logged: false,
    ticket_link: "",
    user: {},
    disabled_scroll: false,
    menus: false,
    show_menus: false,

    cookies: false,
    notification: false,
    link: false,
    text: false,

    selectedDateIndexes: {}
  },

  mutations: {
    setSelectedDateIndex(state, { slug, index }) {
      state.selectedDateIndexes[slug] = index;
    }
  }
  // mutations: {
  //     openSubMenu(state, data) {
  //         state.menus[data.index].show_sub_menu = data.is_open;
  //         console.log(state.menus[data.index])

  //     },
  // },
  // actions: {
  // },
  // modules: {
  // }
});
